import * as THREE from 'three'
import { useFrame, useThree } from '@react-three/fiber'
import { useKeyboardControls } from "@react-three/drei";
import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function useControlAnimal(animalName, actionName, actions) {

    const [subscribeKeys, getKeys] = useKeyboardControls();
    const {
        setPositions,
        setRotation,
        setAction,
        player,
        currentPosition,
        effectiveTimeScale,
    } = useAppStore( useShallow((state) => ({
        setPositions: state.setPositions,
        setRotation: state.setRotation,
        setAction: state.setAction,
        player: state.player,
        currentPosition: state.positions[animalName]?.current,
        effectiveTimeScale: state.effectiveTimeScales[animalName],
    })));

    const direction = new THREE.Vector3();
    const rotation = new THREE.Euler(0, 0, 0, 'YXZ');
    const currentPositionClone = currentPosition.clone();

    const { moveForward, moveBackward, moveLeft, moveRight, jump } = getKeys();

    useFrame((state, delta) => {
        if (player === animalName) {
            if (moveForward) direction.z -= delta;
            if (moveBackward) direction.z += delta;
            if (moveLeft) direction.x -= delta;
            if (moveRight) direction.x += delta;
            //if (jump) direction.y += 1 * delta;

            if (moveLeft || moveRight || moveForward || moveBackward) {
                rotation.y = Math.atan2(direction.x, direction.z);
                setRotation(animalName, rotation)
                
                currentPositionClone.x += direction.x * effectiveTimeScale;
                currentPositionClone.z += direction.z * effectiveTimeScale;
                setPositions(animalName, currentPositionClone)

                actions['die']?.stop();

                actions[actionName].
                    setLoop(THREE.LoopRepeat).
                    setEffectiveTimeScale(effectiveTimeScale).
                    play();
            } else {
                actions[actionName].stop();
            }
        }
    });
};
